import React from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import Dialog from 'components/common/dialog'

const BlockedLocationModal = ({ close, t }) => (
  <Dialog
    closable
    icon={
      <React.Fragment>
        <br />
        <br />
        <Icon src={ICONS.pickUpLocation} size={ICON_SIZE.extraLarge} />
      </React.Fragment>
    }
    onClose={close}
    title={t('Enable your location tracking')}
  >
    <span className={Typo.body2}>
      {t(
        'Turn the location tracking on from your browser settings to find Pomelo Pick Up location near you.',
      )}
    </span>
    <br />
    <br />
  </Dialog>
)

BlockedLocationModal.propTypes = {
  close: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export { BlockedLocationModal }

export default translate('global')(BlockedLocationModal)
